const model = {
    offer: null,
    categories: [],
    products: [],
    units: [],
    loading: false,
    error: null,
};

export default model;